import React, { useState } from 'react'
import { colors, FormControlLabel, Radio, Text } from '@resiliatech/birdsong'
import { ChecklistItemWithResourceInfo } from 'TypeDefs/Goal'
import {
  Dialog,
  DialogTitle,
  ModalContent,
  RadioGroup,
  DialogActions,
  ErrorButton,
  Buttons,
  Button,
} from './TaskDeleteModal.styled'
import { ErrorMessage } from '../TaskModalV2/TaskModalV2.styled'

type TaskDeleteModalProps = {
  open: boolean
  onClose: () => void
  task: ChecklistItemWithResourceInfo
  onDelete: (deleteOption: string) => void
  error: string
}

const deleteOptions = [
  { value: 'single', label: 'Only delete this task' },
  { value: 'future', label: 'Delete this task and all future tasks' },
  { value: 'all', label: 'Delete all past, present, and future tasks' },
]

export const TaskDeleteModal = ({
  open,
  onClose,
  task,
  onDelete,
  error,
}: TaskDeleteModalProps) => {
  const [deleteOption, setDeleteOption] = useState<string>('single')
  const isRecurringTask = Boolean(task.checklistItemGroupId)
  const modalHeader = isRecurringTask ? 'Delete Recurring Task' : 'Delete Task'
  const buttonText =
    isRecurringTask && deleteOption !== 'single' ? 'Tasks' : 'Task'

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      isSingleTask={!isRecurringTask}
    >
      <DialogTitle variant='h5'>{modalHeader}</DialogTitle>
      <ModalContent>
        <Text>
          Team members that are assigned to this task will not be able to see it
          anymore.
        </Text>
        <Text>Are you sure you want to delete this task?</Text>
        {isRecurringTask && (
          <RadioGroup
            value={deleteOption}
            onChange={(e) => setDeleteOption(e.target.value)}
          >
            {deleteOptions.map(({ value, label }) => (
              <FormControlLabel
                key={value}
                value={value}
                control={<Radio />}
                label={label}
              />
            ))}
          </RadioGroup>
        )}
      </ModalContent>
      <DialogActions>
        {error && (
          <ErrorMessage color={colors.feedback.errorDark}>
            {error && error}
          </ErrorMessage>
        )}
        <Buttons>
          <Button addBorder onClick={onClose} variant='outlined'>
            Keep {buttonText}
          </Button>
          <ErrorButton onClick={() => onDelete(deleteOption)}>
            Delete {buttonText}
          </ErrorButton>
        </Buttons>
      </DialogActions>
    </Dialog>
  )
}
